import { ErrorCode } from './types';

// Centralized, reusable UX copy (easy to localize later)
export const ERROR_MESSAGES: Record<ErrorCode, { title: string; description: string }> = {
  // AUTH
  [ErrorCode.AUTH_INVALID_CREDENTIALS]: {
    title: 'Invalid Login Credentials',
    description: 'The email or password you entered is incorrect. Please try again or reset your password.',
  },
  [ErrorCode.AUTH_EMAIL_IN_USE]: {
    title: 'Email Already Registered',
    description: 'An account with this email already exists. Sign in or use a different email.',
  },
  [ErrorCode.AUTH_USER_DISABLED]: {
    title: 'Account Disabled',
    description: 'This account has been disabled. Please contact support if this is unexpected.',
  },
  [ErrorCode.AUTH_REQUIRES_RECENT_LOGIN]: {
    title: 'Please Re‑Login',
    description: 'For security, please sign in again to continue this action.',
  },
  [ErrorCode.AUTH_NETWORK]: {
    title: 'Authentication Network Error',
    description: 'We could not reach the authentication service. Check your internet connection and try again.',
  },

  // FIRESTORE
  [ErrorCode.DB_NOT_FOUND]: {
    title: 'Not Found',
    description: 'The requested data was not found. It may have been removed or never existed.',
  },
  [ErrorCode.DB_PERMISSION_DENIED]: {
    title: 'Permission Denied',
    description: 'You do not have permission to perform this action.',
  },
  [ErrorCode.DB_ALREADY_EXISTS]: {
    title: 'Already Exists',
    description: 'This resource already exists. Try a different value or refresh.',
  },
  [ErrorCode.DB_INDEX_REQUIRED]: {
    title: 'Index Required',
    description: 'This query requires a Firestore index. Ask an admin to create the index in Firebase Console.',
  },
  [ErrorCode.DB_UNAVAILABLE]: {
    title: 'Database Unavailable',
    description: 'Firestore is temporarily unavailable. Please try again in a moment.',
  },
  [ErrorCode.TRANSIENT_BACKEND_UNAVAILABLE]: {
    title: 'Service Temporarily Unavailable',
    description: 'Firestore is temporarily unavailable. Retrying…',
  },

  // FUNCTIONS
  [ErrorCode.FUNC_UNAVAILABLE]: {
    title: 'Service Unavailable',
    description: 'A backend service is temporarily unavailable. Please try again shortly.',
  },
  [ErrorCode.FUNC_INVALID_ARGUMENT]: {
    title: 'Invalid Request',
    description: 'Your request contains invalid data. Please review and try again.',
  },

  // NETWORK
  [ErrorCode.NET_OFFLINE]: {
    title: 'You Are Offline',
    description: 'Please reconnect to the internet and retry.',
  },
  [ErrorCode.NET_TIMEOUT]: {
    title: 'Network Timeout',
    description: 'The request took too long. Check your connection and try again.',
  },

  // PAYMENTS (checkout/eSewa/Khalti/Visa)
  [ErrorCode.PAY_DECLINED]: {
    title: 'Payment Declined',
    description: 'Your payment was declined. Try another method or verify your details and try again.',
  },
  [ErrorCode.PAY_INVALID]: {
    title: 'Invalid Payment Details',
    description: 'Some payment details are invalid or incomplete. Please correct them and try again.',
  },

  // VALIDATION
  [ErrorCode.VALIDATION_FAILED]: {
    title: 'Validation Error',
    description: 'Please fix the highlighted fields and try again.',
  },

  // FALLBACK
  [ErrorCode.UNKNOWN]: {
    title: 'Something Went Wrong',
    description: 'We hit an unexpected error. Please try again.',
  },
};
